<h2 mat-dialog-title>{{ modalTitle }}</h2>
<mat-dialog-content>
  <form [formGroup]="providerForm">
    <div class="upperContainer">
      <mat-form-field appearance="outline" class="addNpi">
        <mat-label>NPI</mat-label>
        <input cdkFocusInitial #npi [matTooltip]="npi.value" matInput placeholder="NPI *" formControlName="npi" (paste)="onNpiPaste($event)"/>
        @if (npiLookupStatus() === 'loading') {
          <mat-spinner matSuffix diameter="18"></mat-spinner>
        }
        @if (npiLookupStatus() === 'found') {
          <mat-hint class="hint-found">Provider NPI found in NPPES NPI registry</mat-hint>
        }
        @if (npiLookupStatus() === 'not-found') {
          <mat-hint class="hint-error">Provider NPI not valid in the NPPES NPI registry</mat-hint>
        }
        @if (npiLookupStatus() === 'error') {
          <mat-hint class="hint-warning">NPPES NPI registry lookup unavailable</mat-hint>
        }
        @if (providerForm.get('npi')?.invalid && (providerForm.get('npi')?.dirty || providerForm.get('npi')?.touched)) {
          <mat-error>
            @if (providerForm.get('npi')?.errors?.['required']) {
              NPI is required.
            }
            @if (providerForm.get('npi')?.errors?.['pattern']) {
              NPI must be exactly 10 digits.
            }
            @if (providerForm.get('npi')?.errors?.['maxlength']) {
              NPI must be no more than 24 characters long.
            }
            @if (providerForm.get('npi')?.errors?.['npiDuplicate']) {
              This NPI already exists in the system.
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="addFirstName">
        <mat-label>First Name</mat-label>
        <input #firstName [matTooltip]="firstName.value" matInput placeholder="First Name *" formControlName="firstName"/>
        @if (providerForm.get('firstName')?.invalid) {
          <mat-error>
            @if (providerForm.get('firstName')?.errors?.['required']) {
              First Name is required.
            }
            @if (providerForm.get('firstName')?.errors?.['maxlength']) {
              First Name must be no more than 35 characters long.
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="addLastName">
        <mat-label>Last Name</mat-label>
        <input #lastName [matTooltip]="lastName.value" matInput placeholder="Last Name *" formControlName="lastName"/>
        @if (providerForm.get('lastName')?.invalid) {
          <mat-error>
            @if (providerForm.get('lastName')?.errors?.['required']) {
              Last Name is required.
            }
            @if (providerForm.get('lastName')?.errors?.['maxlength']) {
              Last Name must be no more than 35 characters long.
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="middleContainer">
      <mat-form-field appearance="outline" class="addSpecialty">
        <mat-label>Specialty</mat-label>
        <mat-select #specialtySelect [matTooltip]="specialtySelect.triggerValue" formControlName="specialty" panelClass="searchable-panel">
          <mat-option disabled>
            <ngx-mat-select-search
              formControlName="specialtySearch"
              placeholderLabel="Search specialties..."
              noEntriesFoundLabel="No specialties found">
            </ngx-mat-select-search>
          </mat-option>
            @for (taxonomy of filteredTaxonomies; track taxonomy.id; let last = $last) {
              <mat-option [value]="taxonomy.id">{{ taxonomy.providerTaxonomyCode }} - {{ taxonomy.providerTaxonomyDescription }}</mat-option>
              @if (!last) {
                <mat-divider></mat-divider>
              }
            }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="addEmail">
        <mat-label>Email</mat-label>
        <input #email [matTooltip]="email.value" matInput placeholder="Email *" formControlName="providerUserEmailAddress"/>
        @if (providerForm.get('providerUserEmailAddress')?.invalid && (providerForm.get('providerUserEmailAddress')?.dirty || providerForm.get('providerUserEmailAddress')?.touched)) {
          <mat-error>
            @if (providerForm.get('providerUserEmailAddress')?.errors?.['required']) {
              Email is required.
            }
            @if (providerForm.get('providerUserEmailAddress')?.errors?.['pattern']) {
              Email is not valid.
            }
            @if (providerForm.get('providerUserEmailAddress')?.errors?.['emailLength']) {
              Email is too long.
            }
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="addPhone">
        <mat-label>Phone</mat-label>
        <input #phone [matTooltip]="phone.value" matInput placeholder="Phone Number" formControlName="phone"/>
        @if (providerForm.get('phone')?.invalid && (providerForm.get('phone')?.dirty || providerForm.get('phone')?.touched)) {
          <mat-error>
            @if (providerForm.get('phone')?.errors?.['maxlength']) {
              Phone must be no more than 24 characters long.
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="dateContainer">
      <mat-form-field appearance="outline" class="addStartDate">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="effectiveDate" placeholder="MM/DD/YYYY" [max]="providerForm.get('expirationDate')?.value"/>
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="addEndDate">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="expirationDate" placeholder="MM/DD/YYYY" [min]="providerForm.get('effectiveDate')?.value"/>
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        @if (providerForm.get('expirationDate')?.errors?.['endBeforeStart'] && providerForm.get('expirationDate')?.touched) {
          <mat-error>End Date must be on or after Start Date.</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="lowerContainer" *ngIf="shouldShowActiveCheckbox()">
      <div class="checkboxContainer">
        <mat-checkbox class="activeCheck" formControlName="isActive">Active</mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="actionContainer">
    <button
      mat-button
      color="primary"
      [disabled]="isSaveDisabled()"
      (click)="onSave()"
      id="saveButton"
    >
      {{ isEdit ? 'Update' : 'Save' }}
    </button>
    <button
      mat-button
      (click)="onClose()">
      Cancel
    </button>
  </div>
</mat-dialog-actions>